import { useAuthCandidateStore } from "@/stores/auth_candidate";
import type { RouteRecordRaw } from "vue-router";

const verifyLogged = ((to: { fullPath: string }) => {
    const candidate = useAuthCandidateStore().candidate;
    if (!candidate) {
        return { name: 'portalLogin', query: { redirect: to.fullPath } };
    }
    if (!candidate.bl_email_confirmado) {
        return { name: 'portalConfirmMail', params: { 'hash': 'sended' }, query: { redirect: to.fullPath } };
    }
});

export const PortalRoutes: RouteRecordRaw[] = [
    {
        path: '',
        name: 'portalJobs',
        component: () => import('./components/jobs/List.vue'),
    },
    {
        path: ':code(\\d+)',
        name: 'portalJobsDetails',
        component: () => import('./components/jobs/List.vue'),
    },
    {
        path: 'login',
        name: 'portalLogin',
        component: () => import('./components/auth/PortalLogin.vue')
    },
    {
        path: 'register',
        name: 'portalRegister',
        component: () => import('./components/auth/PortalRegister.vue')
    },
    {
        path: 'confirm-mail/:hash',
        name: 'portalConfirmMail',
        component: () => import('./components/auth/PortalConfirmMail.vue')
    },
    {
        path: 'recover',
        name: 'portalRecover',
        component: () => import('./components/auth/PortalRecover.vue')
    },
    {
        path: 'processes',
        name: 'portalProcesses',
        component: () => import('./components/processes/List.vue'),
        beforeEnter: verifyLogged
    },
    {
        path: 'form',
        name: 'portalForm',
        component: () => import('./components/form/PortalForm.vue'),
        beforeEnter: verifyLogged
    },
    {
        path: 'form/candidate/:formId',
        name: 'portalCandidateForm',
        component: () => import('./components/form/PortalCandidateForm.vue')
    },
    {
        path: '',
        name: 'portalProfileRedirect',
        redirect: { name: 'portalProfile' },
    },
    {
        path: 'profile',
        name: 'portalProfile',
        component: () => import('./components/profile/PortalProfile.vue'),
        beforeEnter: verifyLogged
    },
    {
        path: 'evaluation',
        name: 'portalEvaluation',
        component: () => import('./components/evaluation/List.vue'),
        beforeEnter: verifyLogged
    },
    {
        path: 'evaluation/:name',
        name: 'evaluationEdit',
        component: () => import('./components/evaluation/Edit.vue'),
        beforeEnter: verifyLogged
    }
]